'use client';

import StatDisplay from 'src/components/MarketStatsBar/StatDisplay';
import { useIfDataQuery } from 'src/hooks/query/ifData/useIfDataQuery';
import { DRIFT_TOKEN_BANK_INDEX } from 'src/environmentVariables/EnvironmentVariables';
import SkeletonValuePlaceholder from 'src/components/SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import useIsMobileScreenSize from 'src/hooks/useIsMobileScreenSize';
import { ZERO_BIGNUM } from 'src/constants/math';
import { ChevronRight } from '@drift-labs/icons';
import { DRIFT_FOUNDATION_URL, PageRoute } from 'src/constants/constants';
import Button from 'src/components/primitives/Button/Button';
import { Drift } from '@drift-labs/icons';
import { getApyFromApr } from 'src/utils/borrowLend';

export default function DriftStakingHeaderStats() {
	const isMobileScreenSize = useIsMobileScreenSize();
	const { data: driftIfData } = useIfDataQuery(DRIFT_TOKEN_BANK_INDEX);

	const yieldPercentage = (() => {
		const apr = driftIfData?.vault?.nextApr ?? 0;
		const apy = getApyFromApr(apr, 'hourly');

		return isNaN(apy) || apy < 0.01 ? '<0.01' : `${apy.toFixed(2)}`;
	})();

	const isLoading = !driftIfData?.vault?.loaded;
	const totalStake = driftIfData?.vault?.totalStakeBigNum ?? ZERO_BIGNUM;

	return (
		<div className="grid grid-cols-2 gap-x-8 gap-y-lg sm:flex">
			<StatDisplay header="Total DRIFT Staked" className="gap-y-sm">
				{isLoading ? (
					<SkeletonValuePlaceholder loading className="h-8 w-18" />
				) : (
					<span className="typo-h4 text-text-default">
						{totalStake.toMillified()}
					</span>
				)}
			</StatDisplay>
			<StatDisplay header="Est. APY" className="gap-y-sm">
				{isLoading ? (
					<SkeletonValuePlaceholder loading className="h-8 w-18" />
				) : (
					<span className="typo-h4 text-text-positive-green-button">
						{yieldPercentage}%
					</span>
				)}
			</StatDisplay>
			<StatDisplay header="About Governance" className="gap-y-sm">
				<Button
					as="a"
					href={DRIFT_FOUNDATION_URL}
					size={isMobileScreenSize ? 'sm' : 'md'}
					variant="secondary"
					leftIcon={Drift}
					openInNewTab
				>
					Drift Foundation
				</Button>
			</StatDisplay>
			<StatDisplay header="Get DRIFT" className="gap-y-sm">
				<Button
					as="a"
					href={`/${PageRoute.swap}/USDC-DRIFT`}
					size={isMobileScreenSize ? 'sm' : 'md'}
					variant="primary"
					rightIcon={ChevronRight}
				>
					Go to Swap
				</Button>
			</StatDisplay>
		</div>
	);
}
